import { createStore, combineReducers } from "redux";
import {
  activeMenuItemReducer,
  solveProblemReducer,
  configRouteReducer
} from "./reducers/activeItemReducer";

const rootReducer = combineReducers({
  activeMenuItem: activeMenuItemReducer,
  solveProblem: solveProblemReducer,
  configRoutes: configRouteReducer
});

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;